import React, { Component } from 'react';
import { connect } from 'react-redux';
import './ImageThumbnail.scss';

import { push } from 'connected-react-router';
import { setCurrentItem } from '../../redux/actions/result.action';
class ImageThumbnail extends Component<{ image: any, navigateTo: any }, {}> {

  open() {
      //TBD
      this.props.navigateTo('/imagepreview', this.props.image)
  }
  
  /**
   * Main render method
   */
  render() {
    return (
      <div className="imagethumbnail" onClick={() => {
        this.open();
      }}>
        <img src={this.props.image.thumbnailUrl} className="thumbnail" alt="thumbnail"/>
      </div>
    );
  }
}


const mapStateToProps = (state: any) => {
  return {
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    navigateTo(path: string, item: any) {
      console.log(item);
      dispatch(setCurrentItem(item));
      dispatch(push(path))
    }
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ImageThumbnail);